// blakfy-cookie/src/presets/vimeo.js — Vimeo player preset (marketing category)

export default {
  name: "Vimeo",
  category: "marketing",
  cookies: [],
  storage: [],
  scriptHosts: ["player.vimeo.com", "vimeo.com"],
  onGrant: (state) => {},
  onRevoke: (state) => {},
};
